import { render, staticRenderFns } from "./cModalViewBills.vue?vue&type=template&id=031a1232"
import script from "./cModalViewBills.vue?vue&type=script&lang=js"
export * from "./cModalViewBills.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports